module.exports = __webpack_public_path__ + "img/android_hover.5341193f.png";